import { h, Component } from 'preact';
import scrollToElement from 'scroll-to-element';
import Cookies from 'js-cookie';
import Uuid from 'uuid-js';

import Header from './header.js';
import Divider from './divider.js';
import Footer from './footer.js';
import Loading from './loading.js';
import BrandHero from './brandHero.js';
import MobileCallToAction from './mobileCallToAction.js';
import Contractor from './contractor.js';
import ContractorList from './contractorList.js';
import Product from './product.js';
import Form from './form.js';
import LocationSearch from './locationSearch.js';
import FormResponse from './formResponse.js';
import Modal from './modal.js';

import style from '../../style/app.sass';

import LandingPageDataHandler from '../util/landingPageDataHandler.js';

const METRICS_LANDING_PAGE_DATA_ID = 1;

const METRICS_ACCOUNT_ID_DEV = 13;
const METRICS_ACCOUNT_ID_STAG = null;
const METRICS_ACCOUNT_ID_PROD = 336;
const METRICS_API_KEY_DEV = 'a9670e31-dd98-4c25-b379-a2d17bd860fa';
const METRICS_API_KEY_STAG = '4fb9e6a9-06f8-4fe8-aeb9-19a3a05511a3';
const METRICS_API_KEY_PROD = 'e1d32757-c87b-47c1-9b99-523d7fd2b8a6';
const METRICS_BASE_URL_DEV =  'https://'+window.location.hostname.toLowerCase()+':8443/';
const METRICS_BASE_URL_STAG = 'https://vsm-staging01.vitalstorm.com/';
const METRICS_BASE_URL_PROD = 'https://metrics.vitalstorm.com/';
const METRICS_API_URL_ENDPOINT = 'api';
const METRICS_FORM_URL_ENDPOINT_DEV = 'booking_form_submission/9340266e-2c2b-4fc6-8521-252368f76df4/';
const METRICS_FORM_URL_ENDPOINT = 'booking_form_submission/NGU3Yjc4NzAwOTZmNmQzZDc1Mzg3ZTY3MWM1MzNhN2E/';
const METRICS_MISSING_REWRITE_ALERT_URL_ENDPOINT = 'email_form_submission/ODI5YWU5NjQyMjI1NWZmZGI2ZjliYTAwMDg5ZTE1YWQ/';

const GOOGLE_MAPS_API_KEY = 'AIzaSyCYBFCo-neWMM7egCE_yMcG9St1MS0Lt0Y';
const RHEEM_CLIENT_ID = "eb7b5720-4147-4af8-8422-d663be06d918.apps.rheemapi.com";
const RHEEM_GOOGLE_ANALYTICS_ACCOUNT_NAME = 'UA-79659612-1';
const RUUD_GOOGLE_ANALYTICS_ACCOUNT_NAME = 'UA-79659612-2';
const RHEEM_BAZAARVOICE_PASSKEY = 'kvkw6nyieiie8dlu4jf56q6tn';
const RUUD_BAZAARVOICE_PASSKEY = 'py5lrkqk22d27qgjohciy1b7z';

const CENTRO_BASIS_SUBMIT_PIXEL_BASE_URL = 'https://pixel.sitescout.com/up/b90ab778fac6a843';

const  getCentroBasisPixelUrl = brand => {
  return CENTRO_BASIS_SUBMIT_PIXEL_BASE_URL+'?button=submit'+brand;
}

const CONSTS = {
  'dev': {
    /*
    'METRICS_ACCOUNT_ID': METRICS_ACCOUNT_ID_DEV,
    'METRICS_API_KEY': METRICS_API_KEY_DEV,
    'METRICS_BASE_URL': METRICS_BASE_URL_DEV,
    'METRICS_FORM_URL_ENDPOINT': METRICS_FORM_URL_ENDPOINT_DEV
    */
    'METRICS_ACCOUNT_ID': METRICS_ACCOUNT_ID_PROD,
    'METRICS_API_KEY': METRICS_API_KEY_PROD,
    'METRICS_BASE_URL': METRICS_BASE_URL_PROD,
    'METRICS_FORM_URL_ENDPOINT': METRICS_FORM_URL_ENDPOINT,

  },
  'stag': {
    'METRICS_ACCOUNT_ID': METRICS_ACCOUNT_ID_STAG,
    'METRICS_API_KEY': METRICS_API_KEY_STAG,
    'METRICS_BASE_URL': METRICS_BASE_URL_STAG,
  },
  'prod': {
    'METRICS_LANDING_PAGE_DATA_ID': METRICS_LANDING_PAGE_DATA_ID,
    'METRICS_ACCOUNT_ID': METRICS_ACCOUNT_ID_PROD,
    'METRICS_API_KEY': METRICS_API_KEY_PROD,
    'METRICS_BASE_URL': METRICS_BASE_URL_PROD,
    'METRICS_API_URL_ENDPOINT': METRICS_API_URL_ENDPOINT,
    'METRICS_FORM_URL_ENDPOINT': METRICS_FORM_URL_ENDPOINT,
    'METRICS_MISSING_REWRITE_ALERT_URL_ENDPOINT': METRICS_MISSING_REWRITE_ALERT_URL_ENDPOINT,
    'GOOGLE_MAPS_API_KEY': GOOGLE_MAPS_API_KEY,
    'RHEEM_CLIENT_ID': RHEEM_CLIENT_ID,
    'RHEEM_GOOGLE_ANALYTICS_ACCOUNT_NAME': RHEEM_GOOGLE_ANALYTICS_ACCOUNT_NAME,
    'RUUD_GOOGLE_ANALYTICS_ACCOUNT_NAME': RUUD_GOOGLE_ANALYTICS_ACCOUNT_NAME,
    'RHEEM_BAZAARVOICE_PASSKEY': RHEEM_BAZAARVOICE_PASSKEY,
    'RUUD_BAZAARVOICE_PASSKEY': RUUD_BAZAARVOICE_PASSKEY,
  }
};

export default class App extends Component {
  constructor(props) {
    super(props);

    const uuid = Uuid.create();

    this.consts = Object.assign({}, CONSTS.prod, CONSTS[props.env]);

    this.state = {
      rheemApiAccessToken: null,
      googleMapsApiKeyIsValid: true,
      searchLocation: null,
      brand: this.getBrand(),
      vsrefdom: this.getVsrefdom(),
      expansion: this.getExpansion(),
      campaignType: this.getCampaignType(),
      source: this.getAdSource(),
      clickId: this.getClickId(),
      device: this.getPlatformType(),
      visitUuid: uuid,
      baseUrl: this.getBaseUrl(props.env),
      contractors: null,
      mergedLandingPageData: null,
      trackingNumber: null,
      infoFetched: false,
      formSendPending: false,
      doShowModal: false,
      modalOverlayHeight: 0,
      modalComponentType: null,
      modalData: null,
      dividerRef: null,
    };

    this.sendClickData();
    this.getGoogleAnalytics(this.state.brand);
    //this.getBVApi(this.state.brand);
    this.setTitleFromBrand();
    this.setFavIconFromBrand();

    this.listBaseElement = null;
    this.showForm = this.showForm.bind(this);
    this.hideModal = this.hideModal.bind(this);
    this.showModal = this.showModal.bind(this);
    this.getLocation = this.getLocation.bind(this);
    this.setSearchLocation = this.setSearchLocation.bind(this);
    this.updateModalOverlayHeight = this.updateModalOverlayHeight.bind(this);
    this.sendFormData = this.sendFormData.bind(this);
    this.sendHttpRequest = this.sendHttpRequest.bind(this);
    this.sendClickToCallData = this.sendClickToCallData.bind(this);
    this.onContractorListLinkClick = this.onContractorListLinkClick.bind(this);
  }
  componentDidMount(){
    this.fetchDataFromMetrics();
    window.addEventListener('resize', this.updateModalOverlayHeight);
  }
  componentWillUnmount(){
    window.removeEventListener('resize', this.updateModalOverlayHeight);
  }
  getConst(name){
    return this.consts[name];
  }
  getBaseUrl(){
    return this.getConst('METRICS_BASE_URL');
  }
  constructQueryString(params){
    const esc = encodeURIComponent;
    return Object.keys(params)
      .map(k => esc(k) + '=' + esc(params[k]))
      .join('&');
  }
  getBaseFetchOptions(){
    let headers = new Headers({
      'Content-Type' : 'application/json',
      'Accept': 'application/json',
      'X-ApiKey': this.getConst('METRICS_API_KEY')
    });
    return {
      headers:  headers,
      credentials: 'omit',
      method: 'GET',
    };
  }
  getErrorMessageFromResponse(response){
    return new Promise((resolve, reject)=>{
      let errorMsg = 'An Error Occured!';
      if(response.statusText){
        errorMsg += '  '+response.statusText;
      }
      response.json().then((json)=>{
        if(json.error && json.error.exception['0']){
          errorMsg = json.error.exception['0'].message;
        }
        resolve(errorMsg);
      }).catch(()=>{
        resolve(errorMsg);
      });
    });
  }
  getPlatformType(){
    if(navigator.userAgent.match(/mobile/i)) {
      return 'Mobile';
    } else if (navigator.userAgent.match(/iPad|Android|Touch/i)) {
      return 'Tablet';
    } else {
      return 'Desktop';
    }
  }
  sendHttpRequest(options){
    return new Promise((resolve, reject)=>{
      const defaults = this.getBaseFetchOptions();
      options = {...defaults, ...options};
      fetch(options.url, options).then((response)=>{
        if(response.ok){
          response.json().then((responseData)=>{
            resolve(responseData);
          });
        }else{
          this.getErrorMessageFromResponse(response).then((errorMsg)=>{reject(errorMsg)});
        }
      });
    });
  }
  sendFormData(formData){
    return new Promise((resolve, reject)=>{
      fetch(this.state.baseUrl+this.getConst('METRICS_FORM_URL_ENDPOINT'), {method: 'POST', body: formData}).then((response)=>{
        if(response.ok){
          response.text().then((html)=>{
            this.showModal(FormResponse,{
              html: html,
              centroBasisPixelUrl: getCentroBasisPixelUrl(this.state.brand)
            });
          });
        }else{
          this.showModal(FormResponse,{
            html: 'We\'re Sorry, the service encountered an error while processing your request. Please try again and contact the server admin if the error persists.'
          });
        }
      });
    });
  }
  getQueryStringParameterByName(name){
    const urlParams = new URLSearchParams(window.location.search);
    if(urlParams.has(name)){
      return urlParams.get(name);
    }
    return false;
  }
  getGoogleAnalyticsNameFromBrand(brand){
    let name = this.getConst('RHEEM_GOOGLE_ANALYTICS_ACCOUNT_NAME');
    if(brand==='ruud'){
      name = this.getConst('RUUD_GOOGLE_ANALYTICS_ACCOUNT_NAME');
    }
    return name;
  }
  getBrand(){
    let brand = 'rheem';
    if(window.location.hostname.toLowerCase().indexOf('ruud') > -1){
      brand = 'ruud';
    }
    if(window.location.hostname.toLowerCase().indexOf('friedrich') > -1){
      brand = 'friedrich';
    }
    if(this.getQueryStringParameterByName('brand')){
      brand = this.getQueryStringParameterByName('brand');
    }
    return brand;
  }
  getCampaignType(){
    let expansion = this.getExpansion();
    if(expansion && expansion.indexOf('repair') > -1){
      return 'repair';
    }
    return 'brand';
  }
  getVsrefdom(){
    let vsrefdom = this.getQueryStringParameterByName('_vsrefdom');
    if(!vsrefdom){
      vsrefdom = this.getBrand();
    }
    return vsrefdom;
  }
  getExpansion(){
    return this.getQueryStringParameterByName('expansion');
  }
  getAdSource(){
    let source = null;
    let gclid = this.getQueryStringParameterByName('gclid');
    if(gclid){
      source = 'adwords';
    }else if(Cookies.get('gclid')){
      source = 'adwords';
    }
    return source;
  }
  getClickId(){
    let clickId = null;
    let gclid = this.getQueryStringParameterByName('gclid')
    if(gclid){
      clickId = gclid;
      Cookies.set('gclid', clickId, { expires: 14 });
    }else if(Cookies.get('gclid')){
      clickId = Cookies.get('gclid');
    }
    return clickId;
  }
  getRheemClientId(){
    return this.getConst('RHEEM_CLIENT_ID');
  }
  getMetricsApiKey(){
    return this.getConst('METRICS_API_KEY');
  }
  getMetricsAccountId(){
    return this.getConst('METRICS_ACCOUNT_ID');
  }
  getMissingRewriteAlertUrl(){
    return this.getConst('METRICS_MISSING_REWRITE_ALERT_URL');
  }
  sendClickData(){
    if(this.state.clickId && this.state.source){
      const baseClickData = {
        source: this.state.source,
        device: this.state.device,
        clickId: this.state.clickId,
        visitUuid: this.state.visitUuid.toString()
      };
      this.sendHttpRequest({
        url: this.state.baseUrl+'conversion_tracking/campaign_ad_click/',
        method: 'POST',
        body: JSON.stringify(baseClickData)
      });
    }
  }
  sendClickToCallData(event){
    if(this.state.clickId && this.state.source){
      const calledNumber = event.target.href.replace(/\D/g,'');
      const baseClickData = {
        source: this.state.source,
        device: this.state.device,
        clickId: this.state.clickId,
        visitUuid: this.state.visitUuid.toString(),
        calledNumber: calledNumber
      };
      this.sendHttpRequest({
        url: this.state.baseUrl+'conversion_tracking/click_to_call_event/',
        method: 'POST',
        body: JSON.stringify(baseClickData)
      });
    }
  }
/*
  getBVApi(brand){
    const bzScript = document.createElement('script');
    bzScript.src = '//display.ugc.bazaarvoice.com/static/'+brand+'-local/en_US/bvapi.js';
    window.document.body.appendChild(bzScript);
  }
*/
  getGoogleAnalytics(brand){
    (function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){
    (i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
    m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
    })(window,document,'script','https://www.google-analytics.com/analytics.js','ga');

    window.ga('create', this.getGoogleAnalyticsNameFromBrand(brand), 'auto');
    window.ga('send', 'pageview');
  }
  googleMapsKeyInvalid(){
    this.setState({
      googleMapsApiKeyIsValid: false
    });
  }
  getGoogleMapsApi(){
    window.gm_authFailure = ()=>{
      this.googleMapsKeyInvalid();
    };
    return new Promise((resolve, reject)=>{
      if(window.google && window.google.maps){
        resolve();
      }else{
        const gmScript = document.createElement('script');
        gmScript.src = '//maps.googleapis.com/maps/api/js?key='+this.getConst('GOOGLE_MAPS_API_KEY')+'&libraries=places';
        gmScript.onload = resolve;
        window.document.body.appendChild(gmScript);
      }
    });
  }
  /*
    old code from last version of page. Since we don't use review anymore, no need to port.
    fetchReviewStatistics(contractorCollection){
      let passkey = (this.get('brand').toLowerCase()==='rheem')?RHEEM_BAZAARVOICE_PASSKEY:RUUD_BAZAARVOICE_PASSKEY;
      if(this.get('contractorCount') > 0){
        return Backbone.$.ajax('//api.bazaarvoice.com/data/statistics.json',
          {
          accepts: {
            json: 'application/json'
          },
          data: {
            apiversion: '5.4',
            passkey: passkey,
            filter: 'productid:'+_.map(contractorCollection.pluck('OrganizationID'), (id)=>{
                return encodeURIComponent(id);
              }).join(','),
            stats: 'reviews'
          },
          dataType: 'json'
        }).done((response)=>{
          _.each(response.Results, (result)=>{
            contractorCollection.findWhere({OrganizationID: result.ProductStatistics.ProductId})
              .set('TotalReviewCount', result.ProductStatistics.ReviewStatistics.TotalReviewCount);
          });
          _.invoke(contractorCollection.where({TotalReviewCount: null}), 'set', 'TotalReviewCount', 0);
        });
      }
    }

  */
  setTitleFromBrand(){
    let title = 'Rheem - Cool Comfort';
    if(this.getBrand() === 'ruud'){
      title = 'Ruud - Reliable Heating & Cooling';
    }
    if(this.getBrand() === 'friedrich'){
      title = 'Friedrich - Boldly Crafted Comfort';
    }
    this.setTitle(title);
  }
  setFavIconFromBrand(){
    let iconType = 'image/png';
    let iconPath = './assets/rheem-fav-logo.png';
    if(this.getBrand() === 'ruud'){
      iconPath = './assets/ruud-fav-logo.png';
    }
    if(this.getBrand() === 'friedrich'){
      iconPath = './assets/friedrich-fav-logo.png';
    }
    this.setFavIcon(iconType, iconPath);
  }
  /*
  setTitleFromLandingPageData(){
    let mergedData = this.landingPageData.getMergedData();
    if(mergedData.city){
      let title = 'Rheem - Cool Comfort in '+mergedData.city;
      if(this.getBrand() === 'ruud'){
        title = 'Ruud - Reliable heating & cooling in '+mergedData.city;
      }
      this.setTitle(title);
    }
  }
  */
  sendRemarketingConversionFromLandingPageData(mergedData){
    if(mergedData.remarketing_code){
      window.google_trackConversion({
        google_conversion_id: parseInt(mergedData.remarketing_code),
        google_remarketing_only: true,
        google_custom_params: window.google_tag_params
      });
    }
  }
  setTitle(title){
    document.title = title;
  }
  setFavIcon(iconType, iconPath){
    const currentIconLink = window.document.head.querySelector('link[rel=icon]');
    if(currentIconLink){
      currentIconLink.remove();
    }
    const newIconLink = document.createElement('link');
    newIconLink.rel = 'icon';
    newIconLink.type = iconType;
    newIconLink.href= iconPath;
    window.document.head.append(newIconLink);
  }
  fetchDataFromMetrics(){
    return this.ensureGeocoder().then(this.getLocation).then((location)=>{
      let params = {};
      if(this.state.expansion){
        params.expansion = this.state.expansion;
      }
      if(this.state.brand){
        params.brand = this.state.brand;
      }
      if(location){
        params.longitude = location.longitude;
        params.latitude = location.latitude;
      }
      this.sendHttpRequest({
        url: this.state.baseUrl+'api/search_third_party_contractor/?'+this.constructQueryString(params),
        method: 'GET',
      }).then((data)=>{
        const lpdh = new LandingPageDataHandler(data.landingPageData, {
          expansion: data.expansion,
          brand: this.state.brand
        });
        this.setState({
          contractors: data.contractors,
          mergedLandingPageData: lpdh.getMergedData(),
          phoneTrackingInfo: data.phoneTrackingInfo,
          expansion: data.expansion,
          infoFetched: true
        });
        if(!data.contractors || data.contractors.length < 1){
          this.showModal(LocationSearch, {
            setSearchLocation: this.setSearchLocation
          });
        }
      }).catch(()=>{
        this.showModal(LocationSearch, {
          setSearchLocation: this.setSearchLocation
        });
      });
    });
  }
  fetchDataFromSearchLocation(){
    return new Promise((resolve, reject)=>{
      this.setState({formSendPending: true}, ()=>{
        let params = {};
        if(this.state.expansion){
          params.expansion = this.state.expansion;
        }
        if(this.state.brand){
          params.brand = this.state.brand;
        }
        if(this.state.searchLocation){
          params = Object.assign(params, this.state.searchLocation);
        }
        this.sendHttpRequest({
          url: this.state.baseUrl+'api/search_third_party_contractor/?'+this.constructQueryString(params),
          method: 'GET',
        }).then((data)=>{
          const lpdh = new LandingPageDataHandler(data.landingPageData, {
            expansion: data.expansion,
            brand: this.state.brand
          });
          this.setState({
            contractors: data.contractors,
            mergedLandingPageData: lpdh.getMergedData(),
            phoneTrackingInfo: data.phoneTrackingInfo,
            expansion: data.expansion,
            infoFetched: true,
            formSendPending: false
          });
          resolve();
        }).catch(()=>{
          this.showModal(LocationSearch, {
            setSearchLocation: this.setSearchLocation
          });
        });;
      });
    });
  }
  ensureGeocoder(){
    return new Promise((resolve, reject)=>{
      if(!this.geocoder){
        this.getGoogleMapsApi().then(()=>{
          this.geocoder = new window.google.maps.Geocoder();
          resolve();
        });
      }else{
        resolve();
      }
    });
  }
  setSearchLocation(location){
    return new Promise((resolve, reject)=>{
      this.setState({searchLocation: location}, ()=>{
        this.fetchDataFromSearchLocation().then(()=>{
          resolve();
        });
      });
    });
  }
  getLocation(model){
    return new Promise((resolve, reject)=>{
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition((position)=>{
          //let point = new google.maps.LatLng(position.coords.latitude, position.coords.longitude);
          resolve(position.coords);
        },()=>{
          if(this.state.searchLocation){
            resolve(this.state.searchLocation);
          }else{
            console.log('Location not enabled');
            resolve();
          }
        });
      } else if(this.state.searchLocation){
        resolve(this.state.searchLocation);
      }else {
        console.log('Location not supported');
        resolve();
      }
    });
  }
  onContractorListLinkClick(e){
    e.preventDefault();
    if(this.listBaseElement){
      scrollToElement(this.listBaseElement,{
        align: 'top'
      });
    }
  }
  showForm(contractor){
    this.showModal(Form, {contractor});
  }
  hideModal(){
    this.setState({
      doShowModal: false,
      modalOverlayHeight:0,
    });
  }
  showModal(componentType, modalData){
    this.setState({
      doShowModal: true,
      modalOverlayHeight: document.body.scrollHeight,
      modalComponentType: componentType,
      modalData: modalData
    });
  }
  updateModalOverlayHeight(){
    this.setState({
      modalOverlayHeight: document.body.scrollHeight
    });
  }
  getLayoutBackground(props, state){
    if(state.brand === 'ruud'){
      if(state.infoFetched){
        return (<div className={style.layoutBackgroundRuud} />);
      }
      return (<div className={[style.layoutBackgroundRuud, style.layoutBackgroundRuudLoading].join(' ')} />);
    }
    return null;
  }
  getContent(props, state){
    const content = [];
    if(state.infoFetched){
      content.push(<BrandHero {...props} {...state} />);
      content.push(<Contractor {...props} {...state}
        showForm={this.showForm}
        sendClickToCallData={this.sendClickToCallData}
        onContractorListLinkClick={this.onContractorListLinkClick}
      />);
      content.push(<Product {...props}  {...state} />);
      if(state.brand === 'ruud'){
        content.push(<div className={style.dividerRuud} />);
      }

      content.push(<ContractorList {...props}  {...state}
        //ref={refComp => this.listBaseElement = refComp.base}
        showForm={this.showForm}
        setSearchLocation={this.setSearchLocation}
        sendClickToCallData={this.sendClickToCallData}
      />);
    }else{
      content.push(<Loading brand={state.brand} />);
    }
    return content;
  }
  getFontClass(brand){
    switch(brand){
      case 'rheem':
        return style.rheemFont;
      case 'ruud':
        return style.ruudFont;
      case 'friedrich':
        return style.friedrichFont;
      default:
        return style.rheemFont;
    }
  }
  render(props, state) {
    const fontClass = this.getFontClass(state.brand);
    const ruudLayoutBackground = this.getLayoutBackground(props, state);
    const content = this.getContent(props, state);
    const footerBackgroundStyle = [style.footerBackground];
    if(state.brand === 'ruud'){
      footerBackgroundStyle.push(style.footerBackgroundRuud);
      if(state.campaignType === 'repair'){
        footerBackgroundStyle.push(style.footerBackgroundRuudRepair);
      }
    }else if(state.brand === 'friedrich'){
      footerBackgroundStyle.push(style.footerBackgroundFriedrich);
      if(state.campaignType === 'repair'){
        footerBackgroundStyle.push(style.footerBackgroundFriedrichRepair);
      }
    }else{
      if(state.campaignType === 'repair'){
        footerBackgroundStyle.push(style.footerBackgroundRepair);
      }
    }
    return (
      <div id="app" className={fontClass}>
        <div id="layout" className={style.layout}>
          {ruudLayoutBackground}
          <Header {...props} {...state} />
          {content}
          <Divider {...props} {...state} ref={c => !this.state.dividerRef && this.setState({ dividerRef: c })} />
          <div className={footerBackgroundStyle.join(' ')}></div>
          <Footer {...props} {...state} />
        </div>
        <MobileCallToAction {...props} {...state}
          showForm={this.showForm}
          sendClickToCallData={this.sendClickToCallData}
          onContractorListLinkClick={this.onContractorListLinkClick}
        />
        <Modal
          {...this.props} {...this.state}
          hideModal={this.hideModal}
          sendFormData={this.sendFormData}
        />
      </div>
    );
  }
}
